import { AdhocItem, AdhocItemType } from "@/models/adhoc-items.model";
import apiClient from "./apiClient";

export async function getAdhocItems(args: {
  userId: number;
  month: number;
  year: number;
}): Promise<AdhocItem[]> {
  const { userId, month, year } = args;
  const res = await apiClient.get(
    `/users/${userId}/adhoc-items?month=${month}&year=${year}`
  );
  const data: AdhocItem[] = res.data as AdhocItem[];
  return data;
}

export async function addHocItem(args: {
  amount: number;
  type: AdhocItemType;
  payslipId?: number;
  userId?: number;
  month?: number;
  year?: number;
}): Promise<AdhocItem> {
  const res = await apiClient.post("/adhoc-items", {
    ...args,
  });
  const data: AdhocItem = res.data as AdhocItem;
  return data;
}

export async function deleteAdhocItem(id: number): Promise<boolean> {
  const res = await apiClient.delete(`/adhoc-items/${id}`);
  return res.data as boolean;
}
